module.exports = __webpack_public_path__ + "static/media/geyilun.009620fd.png";